import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';

import { JourneyPart } from '.';
import { FlightsJourneyInformation, JourneyParts } from 'types/shared';

interface JourneyInfoProps {
  flightsJourneyInformation: FlightsJourneyInformation;
  journeyInfoRef?: React.RefObject<HTMLDivElement>;
}

export const JourneyInfo = ({ flightsJourneyInformation, journeyInfoRef }: JourneyInfoProps) => {
  const { flightJourneyDetails } = flightsJourneyInformation;

  return (
    <UitkSpacing padding={{ inline: 'three' }}>
      <div data-test-id="flight-details">
        {flightJourneyDetails &&
          flightJourneyDetails.journeyParts.map((journeyParts: JourneyParts, index: number) => {
            return (
              <JourneyPart
                journeyParts={journeyParts}
                key={`journeyParts-${index}`}
                journeyIndex={index}
                journeyInfoRef={index === 0 ? journeyInfoRef : null}
              />
            );
          })}
      </div>
    </UitkSpacing>
  );
};
